import { NgZorroIconTheme } from '../icon/ng-zorro-icon-theme.enum';
import { NgZorroIcon } from '../icon/ng-zorro-icon.interface';

export const NG_ZORRO_ICONS: NgZorroIcon[] = [
  {
    name: 'bug',
    theme: NgZorroIconTheme.Fill
  },
  {
    name: 'step-backward',
    theme: NgZorroIconTheme.Fill
  },
  {
    name: 'caret-right',
    theme: NgZorroIconTheme.Fill
  },
  {
    name: 'down-square',
    theme: NgZorroIconTheme.Fill
  },
  {
    name: 'camera',
    theme: NgZorroIconTheme.Fill
  },
  {
    name: 'audio',
    theme: NgZorroIconTheme.Fill
  },
  {
    name: 'bank',
    theme: NgZorroIconTheme.Fill
  },
  {
    name: 'fund',
    theme: NgZorroIconTheme.Fill
  }
];
